import React from 'react';

import { Collapse, CollapseProps } from 'antd/es';

import BounceLoader from '@common/react/components/UI/Loaders/BounceLoader';
import { Rows } from '@common/typescript/objects/List';

import { rest } from '@app/components/Api';
import SearchField from '@app/components/Forms/SearchField/SearchField';
import { PhoneProviderContext } from '@app/components/UI/PhoneProvider/PhoneProvider';
import CarrotDownSVG from '@app/images/CarrotDownSVG';
import PhoneSVG from '@app/images/PhoneSVG';
import { Questions } from '@app/objects/Questions';

const BookingFAQ: React.FC = () => {
	const [search, setSearch] = React.useState<string>('');

	const [loading, setLoading] = React.useState<boolean>(false);
	const [error, setError] = React.useState<string>('');
	const [questions, setQuestions] = React.useState<CollapseProps['items']>([]);

	const contextPhone = React.useContext(PhoneProviderContext);

	if (!contextPhone?.state) throw new Error('Error PhoneProvider context');

	React.useEffect(() => {
		setLoading(true);
		setError('');

		rest.get<Rows<Questions>>(`v1/booking/faqs?text=${search}`)
			.then((res) => setQuestions(res.list.map((question) => ({
				key: question.id,
				label: question.name,
				children: <div dangerouslySetInnerHTML={{ __html: question.text }} />,
			}))))
			.catch((err) => setError(err))
			.finally(() => setLoading(false));
	}, [search]);

	return (
		<div className="bg-white online-booking-information-faq">
			<div className="online-booking-information-faq__content">
				<h3>FAQ</h3>
				<SearchField
					placeholder="i.e. aftercare"
					iconLocation={false}
					widthBorder="0"
					searchBody=""
					setSearch={setSearch}
					newURLAfterSearch={false}
					disabled={loading}
					searchZipCode={false}
				/>

				{!loading ? (
					!error.length ? (
						questions?.length ? (
							<div className="questions">
								<Collapse
									items={questions}
									accordion
									bordered={false}
									expandIcon={() => <CarrotDownSVG />}
									expandIconPosition="end"
									className="questions__collapse"
								/>
							</div>
						) : (
							<div className="format-error-message">Woof! We were not able to find a match. Please try another search.</div>
						)
					) : (
						<div className="format-error-message">{error}</div>
					)
				) : (
					<BounceLoader />
				)}

				<div className="support-center">
					<div className="h3">Support Center</div>
					<a href={contextPhone.state.phoneNumberHref} className="support-center__phone inline-link">
						<PhoneSVG />
						{contextPhone.state.phoneNumberDisplay}
					</a>
				</div>
			</div>
		</div>
	);
};

export default BookingFAQ;
